"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[481],{

/***/ 500481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProductVariantItem": function() { return /* binding */ ProductVariantItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(425336);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(675601);




const ProductVariantItem = (param)=>{
    let { variant , onSelect , visible =true  } = param;
    var ref;
    if (!((ref = variant.options) === null || ref === void 0 ? void 0 : ref.length)) return null;
    const selectedOption = variant.options.find((e)=>e.selected);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Shape */ .b, {
        marginTop: "s8",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS, {
                level: 2,
                color: "textSecondary",
                style: {
                    textTransform: "uppercase"
                },
                children: "".concat(variant.title).concat(selectedOption ? ": ".concat(selectedOption.label) : "")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .k, {
                marginTop: "s8",
                flexWrap: "wrap",
                maxWidth: "calc(100% - 64px)",
                children: variant.options.map((option, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrapperOption, {
                        href: "/".concat(option.url),
                        onClick: (e)=>{
                            e.preventDefault();
                            onSelect(option);
                        },
                        isActive: option.selected,
                        isVisible: visible,
                        borderRadius: "s",
                        margin: [
                            "s0",
                            "s8",
                            "s8",
                            "s0"
                        ],
                        padding: [
                            "s8",
                            "s16"
                        ],
                        blur: option.quantity === 0,
                        className: "att-variant-".concat(option.label, "-sku-").concat(option.sku),
                        children: option.label
                    }, index))
            })
        ]
    });
};
const WrapperOption = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_6__/* .TekoLink */ .A)((param)=>{
    let { isActive , theme , isVisible , blur  } = param;
    return "\n    border: 1px ".concat(isActive ? theme.colors.primary500 : "#e0e0e0", " solid;\n    position: relative;\n    color: ").concat(isActive ? theme.colors.primary500 : "black", ";\n    background-color: ").concat(isVisible || isActive === true ? "#fff" : "#e0e0e0", ";\n    text-transform: capitalize;\n    text-align: center;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: ").concat(isVisible || isActive === true ? "pointer" : "not-allowed", ";\n    opacity: ").concat(blur ? "0.5" : "1", "\n");
});


/***/ })

}]);